
import moment from 'moment'

import DirectionData from'@/models/DirectionData'
import LineTypeData from '@/models/LineTypeData'
import WardData from '@/models/WardData'
import JobData from '@/models/JobData'


var table = {
    main_table_name: 'realestate.clients', // sometimes we need to use the views for filter and the main table for entry
    name: 'realestate.clients_list_filter_2', // use a view instead of a table
    list_views: {
        filters: [
            {
                col: 'sale',
                type: 'multi-select',
                value: null,
            },
            {
                col: 'fullname',
                type: 'text',
                value: null,
            },
            {
                col: 'phone',
                type: 'text',
                value: null,
            },
            {
                col: 'introduced_by',
                type: 'text',
                value: null,
            },
            {
                col: 'status',
                type: 'multi-select',
                value: null,
            },
            {
                col: 'c_needs_group',
                type: 'multi-select',
                value: null,
            },
            {
                col: 'needs_structure',
                type: 'multi-select',
                value: null,
            },
            {
                col: 'needs_direction',
                type: 'multi-select',
                value: null,
            },
            {
                col: 'needs_area_range',
                type: 'multi-select',
                value: null,
            },
            {
                col: 'needs_price_range',
                type: 'multi-select',
                value: null,
            },
            {
                col: 'needs_price_rent_range',
                type: 'multi-select',
                value: null,
            },
            {
                col: 'needs_line_type',
                type: 'multi-select',
                value: null,
            },
            {
                col: 'needs_population_area',
                type: 'multi-select',
                value: null,
            },
            {
                col: 'needs_ward',
                type: 'multi-select',
                value: null,
            },
            {
                col: 'isfavored',
                type: 'boolean',
                value: false
            },
            {
                col: 'c_needs_other',
                type: 'text',
                value: null,
            },
        ],
        sorts: {
            created_at: 'desc'
        },
        columns: [
            {
                key: 'id',
                variant: 'warning'
            },
            'image',
            'fullname',
            'phone',
            'status',
            // 'address',
            'c_needs_group',
            'needs_structure',
            'needs_area_range',
            'needs_price_range',
            'needs_price_rent_range',
            'c_needs_other',
            'needs_ward',
            'needs_population_area',
            // 'isfavored'
        ]
    },
    input_view: {
        forms: [

            


            {
                col: 'code',
                type: 'text',
                value: null, // default value
                defaultValue: 'KH'+moment().format('YYMMDD-HHmmss'),
                required: false,
                visible: true,
                colspan: 3
            },

            
            {
                col: 'fullname',
                type: 'text',
                value: null, // default value
                required: false,
                visible: true,
                colspan: 3
            },
            {
                col: 'phone',
                type: 'text',
                value: null, // default value
                required: false,
                visible: true,
                colspan: 3,
                checkExist: true
            },
            {
                col: 'place_first_met',
                type: 'text',
                value: null, // default value
                required: false,
                visible: true,
                colspan: 3
            },
            {
                col: 'job',
                type: 'select',
                value: null, // default value
                required: false,
                visible: true,
                colspan: 2
            },
            {
                col: 'workplace_address',
                type: 'text',
                value: null, // default value
                required: false,
                visible: true,
                colspan: 3
            },
            {
                col: 'address',
                type: 'text',
                value: null, // default value
                required: false,
                visible: true,
                colspan: 3
            },
            {
                col: 'city',
                type: 'select',
                value: null, // default value
                required: false,
                visible: true,
                colspan: 2
            },
            {
                col: 'town',
                type: 'select',
                value: null, // default value
                required: false,
                visible: true,
                colspan: 2
            },
            {
                col: 'number_called',
                type: 'select',
                value: null, // default value
                required: false,
                visible: true,
                colspan: 2
            },
            {
                col: 'gender',
                type: 'select',
                value: null, // default value
                defaultValue: 'Nam',
                required: false,
                visible: true,
                colspan: 2
            },

            {
                col: 'age',
                type: 'select',
                value: null, // default value
                required: false,
                visible: true,
                colspan: 2
            },

            {
                col: 'birth_date',
                type: 'date',
                value: null, // default value
                required: false,
                visible: true,
                colspan: 2
            },

            {
                col: 'fb_link',
                type: 'text',
                value: null, // default value
                required: false,
                visible: true,
                colspan: 4
            },

            {
                col: 'splitter_1',
                type: 'line',
                value: null, // default value
                required: false,
                visible: true,
                colspan:12
            },

            {
                col: 'add_fullname',
                type: 'text',
                value: null, // default value
                required: false,
                visible: true,
                colspan: 3
            },

            {
                col: 'add_phone',
                type: 'text',
                value: null, // default value
                required: false,
                visible: true,
                colspan: 3
            },

            {
                col: 'add_relationship',
                type: 'text',
                value: null, // default value
                required: false,
                visible: true,
                colspan: 3
            },

            {
                col: 'add_notes',
                type: 'text',
                value: null, // default value
                required: false,
                visible: true,
                colspan: 3
            },

            {
                col: 'splitter_2',
                type: 'line',
                value: null, // default value
                required: false,
                visible: true,
                colspan:12
            },


            {
                col: 'created_at',
                type: 'date',
                value: new Date(),
                defaultValue: moment().format('yyyy-MM-DD'), // default value
                required: false,
                visible: true, // this is generated automatically, we don't need to show to user
                colspan: 2
            },

            // {
            //     col: 'created_by',
            //     type: 'typeahead',
            //     value: '',
            //     defaultValue: 'agnhadat@gmail.com', // default value
            //     required: true,
            //     visible: true, // this is generated automatically, we don't need to show to user
            //     colspan: 2,

            //     options: ['agnhadat@gmail.com', 'nguyenphatlandag@gmail.com'],
            //     optionSerializer: opt => (opt),
            //     optionLabel: opt => (opt),
            //     optionValueName: '', // name of the attribute which will be stored inside the database
            // },

            

            {
                col: 'input_by',
                type: 'select',
                value: '',
                defaultValue: 'TUẤN', // default value
                required: false,
                visible: true, // this is generated automatically, we don't need to show to user
                colspan: 2
            },

            {
                col: 'sale',
                type: 'select',
                value: null, // default value
                defaultValue: 'TUẤN',
                required: false,
                visible: true,
                colspan: 2
            },
            {
                col: 'source',
                type: 'select',
                value: null, // default value
                required: false,
                visible: true,
                colspan: 3
            },
            {
                col: 'introduced_by',
                type: 'text',
                value: null, // default value
                required: false,
                visible: true,
                colspan: 3
            },
            {
                col: 'status',
                type: 'select',
                value: null, // default value
                required: false,
                visible: true,
                colspan: 2
            },

            // {
            //     col: 'client_group',
            //     type: 'multi-select',
            //     value: '',
            //     defaultValue: '', // default value
            //     required: false,
            //     visible: true, // this is generated automatically, we don't need to show to user
            //     colspan: 3
            // },

            {
                col: 'needs_contact',
                type: 'text',
                value: '',
                defaultValue: '', // default value
                required: false,
                visible: true, // this is generated automatically, we don't need to show to user
                colspan: 3
            },

            {
                col: 'preferred_contact',
                type: 'multi-select',
                value: '',
                defaultValue: '', // default value
                required: false,
                visible: true, // this is generated automatically, we don't need to show to user
                colspan: 4
            },

            {
                col: 'splitter_3',
                type: 'line',
                value: null, // default value
                required: false,
                visible: true,
                colspan:12
            },

            // {
            //     col: 'needs_structure',
            //     type: 'multi-select',
            //     value: null, 
            //     required: false,
            //     visible: true,
            //     colspan: 6
            // },
            // {
            //     col: 'needs_direction',
            //     type: 'multi-select',
            //     value: null, 
            //     required: false,
            //     visible: true,
            //     colspan: 6
            // },
            // {
            //     col: 'needs_area_range',
            //     type: 'multi-select',
            //     value: null, 
            //     required: false,
            //     visible: true,
            //     colspan: 6
            // },
            // {
            //     col: 'needs_price_range',
            //     type: 'multi-select',
            //     value: null, 
            //     required: false,
            //     visible: true,
            //     colspan: 6
            // },
            // {
            //     col: 'needs_line_type',
            //     type: 'multi-select',
            //     value: null, 
            //     required: false,
            //     visible: true,
            //     colspan: 6
            // },
            // {
            //     col: 'needs_population_area',
            //     type: 'multi-select',
            //     value: null, 
            //     required: false,
            //     visible: true,
            //     colspan: 6
            // },
            // {
            //     col: 'needs_ward',
            //     type: 'multi-select',
            //     value: null, 
            //     required: false,
            //     visible: true,
            //     colspan: 6
            // },
            // {
            //     col: 'needs_other',
            //     type: 'text',
            //     value: null, 
            //     required: false,
            //     visible: true,
            //     colspan: 6
            // },

            {
                col: 'image',
                type: 'image',
                value: null, // default value
                required: false,
                visible: true,
                colspan: 3
            },



            {
                col: 'images',
                type: 'image_list',
                value: null, // default value
                required: false,
                visible: true,
                colspan: 3
            },

        ],
        group_forms: [
            {
                col: 'sale',
                type: 'select',
                value: null, // default value
                defaultValue: 'TUẤN',
                required: false,
                visible: true,
                colspan: 4
            },

            {
                col: 'status',
                type: 'select',
                value: null, // default value
                required: false,
                visible: true,
                colspan: 8
            },

            // {
            //     col: 'client_group',
            //     type: 'multi-select',
            //     value: '',
            //     defaultValue: '', // default value
            //     required: false,
            //     visible: true, // this is generated automatically, we don't need to show to user
            //     colspan: 8
            // },

             {
                col: 'splitter_3',
                type: 'line',
                value: null, // default value
                required: false,
                visible: true,
                colspan:12
            },

            {
                col: 'needs_structure',
                type: 'multi-select',
                value: null, 
                required: false,
                visible: true,
                colspan: 6
            },

            {
                col: 'needs_direction',
                type: 'multi-select',
                value: null, 
                required: false,
                visible: true,
                colspan: 6
            },
            {
                col: 'needs_area_range',
                type: 'multi-select',
                value: null, 
                required: false,
                visible: true,
                colspan: 6
            },
            {
                col: 'needs_price_range',
                type: 'multi-select',
                value: null, 
                required: false,
                visible: true,
                colspan: 6
            },

            {
                col: 'needs_population_area',
                type: 'multi-select',
                value: null, 
                required: false,
                visible: true,
                colspan: 6
            },
            {
                col: 'needs_ward',
                type: 'multi-select',
                value: null, 
                required: false,
                visible: true,
                colspan: 6
            },

        ]},
    columns: {
        id: {
            'name': 'id',
            'type': 'id',
            'alias': 'ID'
        },
        created_at: {
            'name': 'created_at',
            'type': 'date',
            'alias': 'Ngày tạo',
            formatter: function(value) {
                return moment(value).format('DD/MM/YYYY')
            }
        },
        input_by: {
            'name': 'input_by',
            'type': 'text',
            'alias': 'Người tạo',
            options: [
                'NHI',
                'TUẤN',
                'KIM',
                'CTV-NH',
                'NGUYÊN'
            ]
        },
        code: {
            'name': 'code',
            'type': 'text',
            'alias': 'Mã khách hàng',
        },
        image: {
            'name': 'image',
            'type': 'text',
            'alias': 'Avatar',
        },
        fullname: {
            'name': 'fullname',
            'type': 'text',
            'alias': 'Họ tên',
        },
        phone: {
            'name': 'phone',
            'type': 'text',
            'alias': 'Số điện thoại'
        },
        sale: {
            'name': 'sale',
            'type': 'text',
            'alias': 'Người phụ trách',

            options: [
                'NHI',
                'TUẤN',
                'KIM',
                'CTV-NH',
                'NGUYÊN'
            ]
        },
        needs: {
            'name': 'needs',
            'type': 'text',
            'alias': 'Nhu cầu',
        },
        workplace_address: {
            'name': 'workplace_address',
            'type': 'text',
            'alias': 'Nơi làm việc',
        },
        address: {
            'name': 'address',
            'type': 'text',
            'alias': 'Nơi cư trú',
        },
        job: {
            'name': 'job',
            'type': 'text',
            'alias': 'Nghề nghiệp',
            options: JobData.data
        },
        town: {
            'name': 'town',
            'type': 'text',
            'alias': 'Quận huyện',
            options: [
                'Long Xuyên',
                'Châu Thành',
                'Thoại Sơn',
                'Chợ Mới',
                'Châu Đốc',
                'Châu Phú',
                'Tri Tôn',
                'Tịnh Biên',
                'An Phú',
                'Tân Châu',
                'Phú Tân'
            ]
        },
        city: {
            'name': 'city',
            'type': 'text',
            'alias': 'Tỉnh thành',
            options: [
                'An Giang',
                'Kiên Giang',
                'Đồng Tháp',
                'Cần Thơ',
                'Hồ Chí Minh',
                'Hà Nội'
            ]
        },
        place_first_met: {
            'name': 'place_first_met',
            'type': 'text',
            'alias': 'Nơi gặp lần đầu',
        },
        number_called: {
            'name': 'number_called',
            'type': 'text',
            'alias': 'Số đt gọi',
            options: [
                'xx6852',
                'xx511',
                'xx708',
                'xx9934'
            ]
        },
        birth_date: {
            'name': 'birth_date',
            'type': 'date',
            'alias': 'Sinh nhật',
        },
        
        source: {
            'name': 'source',
            'type': 'text',
            'alias': 'Nguồn khách hàng',
            options: [
                'Web đăng tin',
                'Facebook',
                'Zalo',
                'CTV gth',
                'KH cũ gth',
                'Network gth',
                'Vợt DA',
                'Tờ rơi - card',
                'Telesale',
                'Quét online',
                'Youtube',
                'Facebook Ads',
                'GG Ads',
                'Website',
                'optin form của kdtgoldencity',
                'optin form của angiangnhadat'
            ]
        },

        age: {
            'name': 'age',
            'type': 'text',
            'alias': 'Độ tuổi',

            options: [
                'dưới 22t',
                '22 - 30t',
                '30t - 40t',
                '40t - 50t',
                'trên 50t'
            ]
        },

        gender: {
            'name': 'gender',
            'type': 'text',
            'alias': 'Giới tính',
            options: [
                'Nam',
                'Nữ'
            ]
        },

        fb_link: {
            'name': 'fb_link',
            'type': 'text',
            'alias': 'Link FB'
        },

        add_fullname: {
            'name': 'add_fullname',
            'type': 'text',
            'alias': 'Họ tên liên hệ phụ'
        },

        add_phone: {
            'name': 'add_phone',
            'type': 'text',
            'alias': 'SĐT liên hệ phụ'
        },

        add_relationship: {
            'name': 'add_relationship',
            'type': 'text',
            'alias': 'Địa chỉ liên hệ phụ'
        },

        add_notes: {
            'name': 'add_notes',
            'type': 'text',
            'alias': 'Thông tin khác'
        },
        
        introduced_by: {
            'name': 'introduced_by',
            'type': 'text',
            'alias': 'Giới thiệu bởi'
        },

        c_needs_group: {
            'name': 'c_needs_group',
            'type': 'text',
            'alias': 'Nhóm khách hàng',
            options: [
                'đầu tư lướt sóng',
                'đầu tư trung dài hạn',
                'ng mua sử dụng',
                'kh ký gởi-bán',
                'kh ký gời-cho thuê',
                'kh tìm thuê',
                'Công việc - MQH',
                'Môi giới - CTV'
            ]
        },

        preferred_contact: {
            'name': 'preferred_contact',
            'type': 'text',
            'alias': 'KH thích kiểu tương tác nào',
            options: [
                'thích gọi điện',
                'thích nhắn tin',
                'gặp café trực tiếp',
                'gặp tại nhà',
                'gặp nhanh, tại vị trí bds',
                'thường gặp giờ nào được: trong giờ làm',
                'thường gặp giờ nào được: ngoài giờ',
                'thường gặp giờ nào được: trong tuần',
                'thường gặp giờ nào được: cuối tuần'
            ]
        },

        images: {
            'name': 'images',
            'type': 'text',
            'alias': 'Hình ảnh'
        },
        

        status: {
            'name': 'status',
            'type': 'text',
            'alias': 'Mối quan hệ',
            options: [
                'Data mới',
                'Tiếp cận Ko Sđt',
                'Đã tiếp cận',
                'Đã hẹn gặp',
                'Care KH',
                'Chốt sale',
                'Chăm sóc sau BH',
                'Tạm mất KH',
                'Network',
                'Sai đối tượng',
                'VIP club',
                'Đừng quên'
            ]
        },

        needs_structure: {
            'name': 'needs_structure',
            'type': 'text',
            'alias': 'Kết cấu BĐS',
            options: [
                'đất thổ cư',
                'đất CLN',
                'đất Lúa',
                'đất khác',
                'Nhà khác',
                'Nhà cấp 4',
                '1 trệt 1 lầu',
                '1 trệt 2 lầu',
                '1 trệt 3 lầu',
                'Nhà trên 3 lầu',
                'Biệt thự',
                'Chung cư',
                'Nhà mới xây',
                'Nhà cũ',
                'Nhà kho',
                'Nhà trọ',
                'Nhà thô',
            ]
        },
        needs_direction: {
            'name': 'needs_direction',
            'type': 'text',
            'alias': 'Hướng',
            options: DirectionData.data
        },
        needs_area_range: {
            'name': 'needs_area_range',
            'type': 'text',
            'alias': 'Tầm diện tích',
            options: [
                'dưới 45m2',
                '45-80m2',
                '80-100m2',
                '100-200m2',
                '200-1000m2',
                'trên 1000m2'
            ]
        },
        needs_price_range: {
            'name': 'needs_price_range',
            'type': 'text',
            'alias': 'Khoảng giá mua',
            options: [
                'dưới 700 tr',
                '700-1000',
                '1000-1500',
                '1500-2000',
                '2000-2600',
                '2600-3700',
                '3700-5000',
                'trên 5 tỷ'
            ]
        },
        needs_price_rent_range: {
            'name': 'needs_price_rent_range',
            'type': 'text',
            'alias': 'Khoảng giá thuê',
            options: [
                'Dưới 5tr',
                '5tr - 10tr',
                '10tr - 30tr',
                'Trên 30tr'
            ]
        },
        needs_line_type: {
            'name': 'needs_line_type',
            'type': 'text',
            'alias': 'Loại đường',
            options: LineTypeData.data
        },
        needs_population_area: {
            'name': 'needs_population_area',
            'type': 'text',
            'alias': 'Khu dân cư',
            options: [
                'Golden City',
                'Golden City GD2',
                'NOXH Golden City',
                'Bắc HHH',
                'Tây Khánh 8',
                'Lý Thái Tổ',
                'Nam Kinh',
                'Kênh đào nối dài',
                'Tây Đại Học',
                'Tây Đại Học GD2',
                'Khu AB - Tỉnh đoàn - Nam TB',
                'Khu B4 - Thiên Lộc',
                'Phú Quý',
                'Xẻo Trôm',
                'Xẻo Trôm 3',
                'Tây Sông Hậu',
                'Tây Sông Hậu GD2',
                'Lê Chân',
                'VPMQ',
                'Làng Giáo Viên',
                'Làng Giáo Viên 2',
                'Phú Cường',
                'Khu Chợ Cái Sao',
                'An Châu Central',
                'Khu Chợ Cần Đăng'
            ]
        },
        needs_ward: {
            'name': 'needs_ward',
            'type': 'text',
            'alias': 'Phường',
            options: WardData.data
        },
        c_needs_other: {
            'name': 'c_needs_other',
            'type': 'text',
            'alias': 'Nhu cầu cụ thể'
        },
        needs_contact: {
            'name': 'needs_contact',
            'type': 'text',
            'alias': 'Nhu cầu liên hệ'
        },

        needs_product: {
            'name': 'needs_product',
            'type': 'text',
            'alias': 'Thông tin bổ sung đối với sản phẩm',
            options: [
                'đúng nhu cầu giá cả ko vấn đề',
                'chỉ cần giá thấp lướt sóng',
                'cần nhà hoàn thiện ko phải làm gì thêm',
                'cần nhà cơ bản về có thể sửa theo ý',
                'DT nhỏ nhưng ngay trung tâm',
                'DT lớn ra ven cũng được',
                'tin tưởng phong thủy',
                'ko được dính cống trụ',
                'nhìn ra công viên bờ sông',
                'tránh tiếng ồn',
                'có sân vườn sân oto',
            ]
        },

        created_by: {
            'name': 'created_by',
            'type': 'text',
            'alias': 'Email người tạo'
        },
        isfavored: {
            'name': 'isfavored',
            'type': 'boolean',
            'alias': 'Ưa thích'
        }
    },
    preview: [  
        {
            col: 'image',
            type: 'image',
            value: null, // default value
            required: false,
            visible: true,
            colspan: 3
        },       
        {
            col: 'fullname',
            type: 'text',
            value: null, // default value
            required: false,
            visible: true,
            colspan: 4
        },
        {
            col: 'place_first_met',
            type: 'text',
            value: null, // default value
            required: false,
            visible: true,
            colspan: 5
        },
        {
            col: 'job',
            type: 'select',
            value: null, // default value
            required: false,
            visible: true,
            colspan: 4
        },
        {
            col: 'workplace_address',
            type: 'text',
            value: null, // default value
            required: false,
            visible: true,
            colspan: 4
        },
        {
            col: 'city',
            type: 'select',
            value: null, // default value
            required: false,
            visible: true,
            colspan: 4
        },
        {
            col: 'address',
            type: 'text',
            value: null, // default value
            required: false,
            visible: true,
            colspan: 4
        },
        {
            col: 'town',
            type: 'select',
            value: null, // default value
            required: false,
            visible: true,
            colspan: 4
        },
        {
            col: 'number_called',
            type: 'select',
            value: null, // default value
            required: false,
            visible: true,
            colspan: 4
        },
        {
            col: 'splitter_1',
            type: 'line',
            value: null, // default value
            required: false,
            visible: true,
            colspan:12
        },

        {
            col: 'source',
            type: 'select',
            value: null, // default value
            required: false,
            visible: true,
            colspan: 6
        },

        {
            col: 'c_needs_group',
            type: 'multi-select',
            value: '',
            defaultValue: '', // default value
            required: false,
            visible: true, // this is generated automatically, we don't need to show to user
            colspan: 6
        },
    ],
}

export default {
    main_table_name: table.main_table_name,
    table_name: table.name,
    filter_orders: table.filter_orders,
    list_views: table.list_views,
    input_view: table.input_view,
    columns: table.columns,
    preview: table.preview
}